import ItemCategory from "../Models/ViewModels/ItemCategory";
import PageModel from "../Models/ViewModels/PageModel";
import MakeRequest from "../Utilities/MakeRequest";

export function fetchServicesList(searchValue: string, sortValue: string, sortAscending: boolean, currentPage: number, pageSize: number): Promise<PageModel<ItemCategory>> {
	return new Promise<PageModel<ItemCategory>>((resolve, reject) => {
		new MakeRequest(`/api/Services/search?searchValue=${searchValue}&SortValue=${sortValue}&SortAscending=${sortAscending}&Page=${currentPage}&Size=${pageSize}`)
			.send()
			.then((response: string) => {
				resolve(JSON.parse(response));
			}, reject);
	});
}

export function fetchCreateServiceModal(): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest('/DomainAdmin/Services/Create')
			.send()
			.then(resolve, reject);
	});
}

export function createService(itemCategoryId: string, serviceFormData: FormData): Promise<number> {
	return new Promise<number>((resolve, reject) => {
		new MakeRequest(`/api/Services/Create?itemCategoryId=${itemCategoryId}`, "Post")
			.send(serviceFormData)
			.then(resolve, reject);
	});
}

export function fetchUpdateServiceModal(serviceId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/DomainAdmin/Services/update?id=${serviceId}`)
			.send()
			.then(resolve, reject);
	});
}

export function updateService(serviceFormData: FormData): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		new MakeRequest(`/api/Services/Update`, "Put")
			.send(serviceFormData)
			.then(resolve, reject);
	});
}

export function updateServiceDisplayOrder(serviceId: string, displayOrder: number): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest(`/api/Services/UpdateDisplayOrder?serviceId=${serviceId}&displayOrder=${displayOrder}`, "Put", headers)
			.send()
			.then(resolve, reject);
	});
}

export function fetchDeleteServiceModal(serviceId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/DomainAdmin/Services/delete?id=${serviceId}`)
			.send()
			.then(resolve, reject);
	});
}

export function deleteService(serviceId: string): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest(`/api/Services/Delete?id=${serviceId}`, "delete", headers)
			.send()
			.then(resolve, reject);
	});
}

export function fetchVariantsDisplayOrderModal(serviceId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/DomainAdmin/Services/VariantsDisplayOrder?id=${serviceId}`)
			.send()
			.then(resolve, reject);
	});
}
